export default __webpack_public_path__ + "static/media/landscape1-MULTIPLY-shadows.acf5694e.png";